// Layout
const dashboardLayout = () => import('@/layouts/CompanyLayout/DashboardLayout/dashboardLayout.vue')

const superAdminDashboard = () => import('./views/index')

// start Routes
export default [
  {
    path: '/company',
    component: dashboardLayout,
    children: [{
      path: '',
      name: 'companyDashboard',
      meta: {
        name: 'companyDashboard',
        userType: '',
        permission: '',
        role: 'transportation.company_owner'
      },
      component: superAdminDashboard
    }
    ]
  }
]
